import { Module } from 'vuex';
import { RootState } from 'frontend/types';

import { roughNumberFormat } from 'frontend/utils/formatting';

interface NumCoursesState {
  num_courses: number;
}

const numCourses: Module<NumCoursesState, RootState> = {
  namespaced: true,
  state: {
    num_courses: 0,
  },
  getters: {
    roughNumCourses(state): string {
      return roughNumberFormat(state.num_courses);
    },
  },
  mutations: {
    setValue(state: NumCoursesState, value: NumCoursesState) {
      Object.assign(state, value);
    },
  },
};

export default numCourses;
